<template>
  <div>
    <validation-observer ref="simpleRules">
      <!-- Distric ID -->
      <b-form-group
        label="Kecamatan/Kabupaten/Provinsi"
        label-for="v-district"
      >
        <validation-provider
          #default="{ errors }"
          name="District"
          :rules="requiredList.includes('district') ? 'required' : ''"
        >
          <v-select
            id="v-district"
            v-model="form.district"
            :options="dataSearch"
            label="district_name"
            :loading="isLoading"
            :state="errors.length > 0 ? false : null"
            :filterable="false"
            @search="onSearchAddress"
          >
            <template #option="option">
              {{ option.district_name }}, {{ option.city_name }}, {{ option.province_name }}
            </template>
            <template #no-options="">
              Alamat tidak ditemukan.
            </template>
            <template #selected-option="{ district_name, city_name, province_name}">
              {{ district_name }}, {{ city_name }}, {{ province_name }}
            </template>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Detail Alamat -->
      <b-form-group
        label="Detail Alamat"
        label-for="v-address"
      >
        <validation-provider
          #default="{ errors }"
          name="Detail Alamat"
          :rules="requiredList.includes('alamat') ? 'required' : ''"
        >
          <b-form-textarea
            id="v-address"
            v-model="form.address"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Kode Pos -->
      <b-form-group
        label="Kode Pos"
        label-for="v-postal_code"
      >
        <validation-provider
          #default="{ errors }"
          name="Kode Pos"
          :rules="requiredList.includes('kode') ? 'required' : ''"
        >
          <b-form-input
            id="v-postal_code"
            v-model="form.postal_code"
            max="5"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </validation-observer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BFormGroup,
  BFormInput,
  BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'BrandFormAddress',
  components: {
    vSelect,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    requiredList: {
      type: Array,
      default: () => (['district', 'alamat', 'kode']),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      filteredOptions: [],
      country: null,
    }
  },
  computed: {
    ...mapState('address', ['dataSearch', 'isLoading']),
  },
  methods: {
    ...mapActions('address', ['getDataSearchDistrict']),
    async onSearchAddress(text) {
      await this.getDataSearchDistrict({ name: text })
    },
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
  },
}
</script>
